import DirectionServicesView from '@/components/DirectionServicesView';

export default function DirectionPage(props) {
  const { id, title, slug, directions, banner = {}, banner_alt, short_content, services, current_direction, blocks, questions, h1, gallery } = props;

  const image = {
    desktop: banner?.main_page_desktop,
    tablet: banner?.main_page_tablet,
    mobile: banner?.main_page_mobile,
  };

  const directionBanner = {
    id,
    title: h1 || title,
    image,
    banner_alt,
    theme: 'dark',
  };

  return (
    <DirectionServicesView
      banners={[directionBanner]}
      directions={directions}
      short_content={short_content}
      services={services}
      blocks={blocks}
      questions={questions}
      current_direction={current_direction}
      activeSlug={slug}
      gallery={gallery}
    />
  );
}
